<ng-container *ngIf="isLoaded">
  <div class="background-blue">
    <div class="container" style="padding-top:20px;padding-bottom:20px;">
      <h1 style="font-size:22.5px;"><adp-label labelKey="SpeedTest_Heading"></adp-label></h1>
      <span><adp-label labelKey="SpeedTest_OverviewCopy"></adp-label></span>
    </div>
  </div>

  <div class="container" style="margin-top:20px;">
    <adp-setting key="URL_External_Speedcheck"></adp-setting>
    <div class="speedtest-wrapper">
      <iframe #speedTestFrame title="Speed Test Check" class="speedtest-frame" frameBorder="0" [src]="urlSafe"></iframe>
    </div>
    <adp-setting key="SpeedTest_Promo_IsEnabled"></adp-setting>
    <adp-setting key="SpeedTest_Promo_IsPromoAppType"></adp-setting>

  </div>
  <div *ngIf="isTechServicesChatEnabled" ifSettingTrue="SpeedTest_Promo_IsEnabled" class="background-fill-container" style="margin-top:30px;">
    <ng-container>
      <app-promotion-panel [isDisabledController]="isPromotionDisabled" [promoSlot]="promoSlot"
        gaName="Speedcheck Promotional Panel">
      </app-promotion-panel>
    </ng-container>
  </div>
</ng-container>
